module.exports = __webpack_public_path__ + "img/no-image.20161117.svg";